<template>
  <div>
    <v-card class="white rounded-lg">
      <v-card-title class="secondary--text">{{title}}</v-card-title>
      <v-card-text>
        <m-datatable :show-filter-row="false" :headers="headers" :apiUrl="url" :filters.sync="filters"
                     @dblclick:row="(e, row) => $router.push(to(row.item))"
                     ref="datatable" :show-select="false">
          <template #item.detail="{ item }">
            <detail-link :to="to(item)"/>
          </template>

        </m-datatable>
      </v-card-text>
    </v-card>
  </div>

</template>

<script>
export default {
  name: "BusinessAffiliateReport",
  components: {},
  props: {},
  data() {
    return {
      url: "affiliate/businessAffiliateReport/all",
      filters: {},
    };
  },
  computed: {
    title() {
      return this.setDocumentTitle('گزارش فروش کسب و کار ها')
    },

    headers() {
      return [
        {
          text: "کسب و کار",
          value: "name",
        },
        {
          text: "نوع کسب و کار",
          value: "business_type_display",
        },
        {
          text: "تعداد سفارشات",
          value: "factors_count",
          type: 'numeric'
        },
        {
          text: "فروش کل",
          value: "sale_price_sum",
          type: 'numeric'
        },
        {
          text: "تعداد اقلام فروش",
          value: "sale_quantity_sum",
          type: 'numeric'
        },
        {
          text: " فروش پرداخت شده",
          value: "paid_price_sum",
          type: 'numeric'
        },
      ];

    },
  },
  methods: {
    to(item) {
      return {
        name: "BusinessDetail",
        params: {
          id: item.id,
        },
      };
    },

  },
};
</script>

<style scoped lang="scss">
</style>